import React, { useState, useContext, useEffect } from "react"
import { Menu } from "semantic-ui-react"
import styled, { css } from "styled-components"
import { ProductContext } from "../../providers/ProductProvider"
import { FilterContext } from "../../providers/FilterProvider"
import { device } from "../../theme"
import PriceRange from "../PriceRange"

const MenuItem = styled(Menu.Item)`
  .ui.menu &.item {
    border-radius: 0;
    box-shadow: none;
    transition: box-shadow 0.2s ease-in;
    padding: 8px 18px;

    &.price-item::before {
      content: none;
    }

    @media ${device.tablet} {
      display: none;
    }

    &:hover {
      background: #fff;
    }
  }
  .ui.menu &.active.item {
    box-shadow: inset 0px -4px 0px 0px ${props => props.theme.colors.green};
    background: #fff;
  }

  ${props =>
    props.loading &&
    css`
      opacity: 0.2;
    `}
`

function Sorting() {
  const [active, setActive] = useState("relevans")
  const { isLoading } = useContext(ProductContext)
  const { state, dispatch } = useContext(FilterContext)

  const handleSort = sortBy => {
    setActive(sortBy)
    dispatch({
      sortedByRelevans: sortBy === "relevans",
      sortedByLowest: sortBy === "lowest",
      sortedByHighest: sortBy === "highest",
      sortedByOffer: sortBy === "offer",
    })
  }

  const highlightWords = input => {
    dispatch({ searchInput: input })
  }

  useEffect(() => {
    const productTitle = document.querySelectorAll(".product-title")
    const reg = new RegExp(state.searchInput, "gi")

    if (productTitle?.length) {
      productTitle.forEach((title, key) => {
        if (title.innerText.match(reg)) {
          title.innerHTML = title.innerText.replace(
            reg,
            match => `<mark>${match}</mark>`
          )
        }
      })
    }
  }, [state.filteredProducts, state.searchInput])

  return (
    <Menu style={{ borderRadius: 0 }}>
      <MenuItem
        name="relevans"
        active={active === "relevans"}
        onClick={
          isLoading ? e => e.preventDefault() : () => handleSort("relevans")
        }
      >
        Relevans
      </MenuItem>
      <MenuItem
        name="lowest"
        loading={isLoading}
        active={active === "lowest"}
        onClick={
          isLoading ? e => e.preventDefault() : () => handleSort("lowest")
        }
      >
        Pris (Lavest)
      </MenuItem>
      <MenuItem
        name="highest"
        loading={isLoading}
        active={active === "highest"}
        onClick={
          isLoading ? e => e.preventDefault() : () => handleSort("highest")
        }
      >
        Pris (Højest)
      </MenuItem>
      <MenuItem className="price-item">
        <PriceRange />
      </MenuItem>
      <Menu.Menu position="right">
        <div
          style={{ minWidth: 320 }}
          className="ui right aligned category search item"
        >
          <div className="ui transparent icon input">
            <input
              value={state.searchInput}
              onChange={e => highlightWords(e.target.value.toLowerCase())}
              className="prompt"
              type="text"
              placeholder="Søg efter tøj"
            />
            {state.searchInput ? (
              <i
                onClick={() => highlightWords("")}
                className="close link icon"
              />
            ) : (
              <i className="search link icon" />
            )}
          </div>
          <div className="results" />
        </div>
      </Menu.Menu>
    </Menu>
  )
}

export default Sorting
